import React from 'react';

import { Form, Row, Col, Input, Select, Button, DatePicker, Cascader, } from 'antd';

import {
    SearchOutlined,
    ReloadOutlined,
} from '@ant-design/icons';

const { RangePicker } = DatePicker;
const { Option } = Select;

const options = [
    {
        value: 'zhejiang',
        label: 'Zhejiang',
        children: [
            {
                value: 'hangzhou',
                label: 'Hangzhou',
                children: [
                    {
                        value: 'xihu',
                        label: 'West Lake',
                    },
                ],
            },
        ],
    },
    {
        value: 'jiangsu',
        label: 'Jiangsu',
        children: [
            {
                value: 'nanjing',
                label: 'Nanjing',
                children: [
                    {
                        value: 'zhonghuamen',
                        label: 'Zhong Hua Men',
                    },
                ],
            },
        ],
    },
];

class AftersaleSearchForm extends React.Component {

    render() {
        const dateFormat = 'YYYY/MM/DD';
        const onFinishFailed = (errorInfo: any) => {
            console.log('Failed:', errorInfo);
        };
        const onReload = () => {
            window.location.reload();
        };
        return (

            <Form
                layout='inline'
            >
                <Row gutter={[18, 18]}>
                    <Col>
                        <Form.Item
                            name="keyword"
                            label="关键词"
                        >
                            <Input placeholder="订单号、订单信息" />
                        </Form.Item>
                    </Col>
                    <Col>
                        <Form.Item
                            name="status"
                            label="状态"
                        >
                            <Select
                                dropdownMatchSelectWidth={false}
                                defaultValue="-1"
                            >
                                <Option value="-1">全部</Option>
                                <Option value="0">处理中</Option>
                                <Option value="1">已同意</Option>
                                <Option value="2">已拒绝</Option>
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col>
                        <Form.Item
                            name="type"
                            label="种类"
                        >
                            <Select
                                dropdownMatchSelectWidth={false}
                                defaultValue="-1"
                            >
                                <Option value="-1">全部</Option>
                                <Option value="1">售后</Option>
                                <Option value="2">退款</Option>
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col>
                        <Form.Item
                            name="applyTime"
                            label="申请时间"
                        >
                            <RangePicker
                                format={dateFormat}
                            />
                        </Form.Item>
                    </Col>
                    <Col>
                        <Form.Item
                            name="confirmTime"
                            label="处理时间"
                        >
                            <RangePicker
                                format={dateFormat}
                            />
                        </Form.Item>
                    </Col>
                    <Col>
                        <Form.Item
                            name="reasonCategory"
                            label="原因分类"
                        >
                            <Select
                                dropdownMatchSelectWidth={false}
                                defaultValue="-1"
                            >
                                <Option value="-1">全部</Option>
                                <Option value="1">天气原因</Option>
                                <Option value="2">行程有变</Option>
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col>
                        <Form.Item
                            name="reason"
                            label="原因"
                        >
                            <Select
                                dropdownMatchSelectWidth={false}
                                defaultValue="-1"
                            >
                                <Option value="-1">全部</Option>
                                <Option value="1">导游态度恶</Option>
                                <Option value="2">天气变化导致行程取消</Option>
                                <Option value="3">临时有事，无法如期出行</Option>
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col>
                        <Button type="primary" htmlType="submit">
                            <SearchOutlined />搜索
						</Button>
                    </Col>
                    <Col>
                        <Button
                            type="default"
                            onClick={onReload}
                        >
                            <ReloadOutlined />重置
						</Button>
                    </Col>
                </Row>
            </Form>

        )
    }
}

export default AftersaleSearchForm;